import { render, staticRenderFns } from "./MobileFooterFixed.vue?vue&type=template&id=d02957e6"
import script from "./MobileFooterFixed.vue?vue&type=script&lang=js"
export * from "./MobileFooterFixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports